var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"line-numbers"},_vm._l((_vm.numbers),function(number){return _c('div',{key:number},[_vm._v(" "+_vm._s(number)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }